import Player from 'widget/player-widget/components/player/player';
import SocialShare from 'widget/player-widget/components/social-share/social-share';

import { OVERLAY_ACTION_TYPES } from 'widget/player-widget/components/player/overlay-actions/overlay-action-utils';


export {
  Player,
  SocialShare,

  OVERLAY_ACTION_TYPES,
};

export default Player;



// WEBPACK FOOTER //
// ./src/widget/player-widget/index.js